<template>
<div class="page page_collect">
    <van-tabs v-model="active" @change="changeTab">
        <van-tab title="商品" name="a"></van-tab>
        <van-tab title="头条" name="b"></van-tab>
        <!-- <van-tab title="专题" name="c"></van-tab> -->
		<van-tab title="定制" name="d"></van-tab>
    </van-tabs>
    <!-- 专题 -->
    <!-- <div class="list topic" v-if="active == 'c'">
            <div class="item">
                <div class="item_t">
                    <img :src="this.publicPath+'statics/images/temp/tu01.png'" alt="" class="tu">
                </div>
                <div class="item_tips clearfix">
                   <div class="title f-l">非遗文创</div>
                   <div class="f-r like liked">已收藏</div>
                </div>
                <div class="item_desc">创意生活，惠及你我。一点点调侃趣话，加一点点轻奢美，让文化创意包装我们的日常用品，茶具、电器、精美礼盒，等等，应有尽有，让您做一个精致生活的主人创意生活，惠及你我。一点点调侃趣话，</div>
            </div>
        </div> -->
    <!-- 有收藏 商品 -->
    <div class="list good" v-if="active == 'a' && have_goods" ref="goodsList">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="getGoods">
            <div class="item clearfix" v-for="(goods,index) in goodsList" :key="index">
                <div :class="goods.is_blockchain ? 'item_l f-l blockchain' : 'item_l f-l'">
                    <img :src="goods.good_thumb? imageUrl+goods.good_thumb : $publicData.intangibleDefault" alt="" class="" @click="toGoodsDetail(goods)">
                </div>
                <div class="item_r f-l">
                    <div class="item_r_t" @click="toGoodsDetail(goods)">
                        <div class="title">{{ goods.good_title }}</div>
                        <!-- <div class="sku slh_s">颜色：400cm*400cm</div> -->
                    </div>
                    <div class="item_r_b">
                        <div class="price"><span class="tag_cash">¥</span>{{ goods.good_price }}</div>
                        <div class="del" @click="cancelGoodsCollection(goods)">删除</div>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
    <!-- 无收藏 商品 -->
    <div class="list good" v-if="active == 'a' && !have_goods" ref="goods">
        <div class="page_default">
            <div class="bg">
                <img :src="publicPath+'statics/images/no_collect.png'" alt="" class="tu">
            </div>
            <div class="tips">暂无收藏</div>
            <div class="btn" @click="goshop">去逛逛</div>
        </div>
    </div>
    <!-- 头条 -->
    <div class="list page_comment" v-if="active == 'b'">
        <van-list v-model="loading_toutiao" :finished="finished_toutiao" finished-text="没有更多了" :immediate-check="false" @load="getHeadLineList">
            <div class="item" v-for="(item,key) in headlineList" :key="'0'+key">
                <div class="item_t_wrap">
                    <div class="item_t">
						<van-image fit="cover" :src="item.push_thumb ? ( $publicData.withHttpStart(item.push_thumb)? item.push_thumb : imageUrl+item.push_thumb) : $publicData.headLineTouxiang" class="thumb" :show-error="true" :error-icon="$publicData.headLineTouxiang" :show-loading="false" />
                        <div class="item_t_r">
                            <div class="user_name">{{item.push_name}}</div>
                            <div class="time">{{item.headline_time}}</div>
                        </div>
                    </div>
					<div class="item_t_b">
						<div :class="item.is_collect ? 'action collect collected' : 'action collect'" @click="clickCollect(item)"></div>
					</div>
                </div>
                <div class="item_nr" @click="goDetail(item)">{{item.headline_type != 0 ? item.headline_title : item.headline_type == 0 && item.desc_hide==1 ? item.describe_hide : item.headline_describe}}
                </div>
                <div class="item_nr more" v-if="item.desc_hide"  @click="lookAllFun(item)">查看全文</div>
				<div class="item_nr more"  v-if="item.desc_hide == 0"  @click="hideFun(item)">收起全文</div>
				<!-- 多张小图 -->
				<div class="item_nr_tu"  v-if="item.headline_type == 0 && item.imagesArr">
					<div class="tu_wrap" v-for="(img,key) in item.images_hide ? item.imagesSlice : item.imagesArr" :key="key" @click="zhanshitupian(item,item.images_hide ? item.imagesSlice : item.imagesArr,key)">
						<van-image class="tu" fit="cover" :src="imageUrl+img" :show-error="false" :show-loading="false"/>
						<div class="mark" v-if="item.images_hide && key == 2">{{'+'+ (item.imagesArr.length -3)}}</div>
					</div>
                </div>
				<!-- 一张大图 -->
				<div class="item_nr_tu single" v-if="item.headline_type == 2" @click="goDetail(item)">
					<van-image fit="cover" :src="imageUrl+item.thumb" class="tu" :show-error="false" :show-loading="false" />
				</div>
				<!-- 一张大图 + 视频 -->
				<div class="item_nr_tu single" v-if="item.headline_type == 1" @click="goDetail(item)">
					<van-image fit="cover" :src="imageUrl+item.thumb" class="tu mark" :show-error="false" :show-loading="false" />
				</div>
                <!-- <div class="item_b">
                    <div class="action comment" @click="goDetail(item)">评论{{ '('+  item.num.comment_num + ')'}}</div>
                    <div :class="item.is_collect ? 'action collect collected' : 'action collect'" @click="clickCollect(item)">收藏{{ '('+  item.num.collect_num + ')'}}</div>
                    <div :class="item.is_like ? 'action like liked' : 'action like'" @click="clickLike(item)">点赞{{ '('+  item.num.like_num + ')'}}</div>
                </div> -->
            </div>
        </van-list>
    </div>
	<!-- 头条的 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
	<!-- 定制 -->
	<div class="page_dingzhi page_toutiao" v-if="active == 'd'">
		<van-list v-model="loading_dingzhi" :finished="finished_dingzhi" finished-text="没有更多了" @load="getDataDingzhi" :immediate-check="false">
			<div class="list">
                <div class="item" v-for="(item,index) in dingzhiList" :key="index">
					<div class="item_title slh" @click="goDingzhiDetail(item)">{{item.descript}}</div>
                    <div class="item_spec" @click="goDingzhiDetail(item)">
                        <div class="spec">类型: <span class="red" v-if="item.cate">{{item.cate.title}}</span></div>
                        <div class="spec">价格: <span class="red">{{item.price_range}}</span>/个</div>
                    </div>
                    <div class="item_tu more">
                        <div class="tu_wrap" v-for="(image,index) in item.images_hide ? item.imagesSlice : item.images" :key="index" @click="zhanshitupian(item,item.images_hide ? item.imagesSlice : item.images,index)">
                            <van-image fit="cover" :src="imageUrl+image" class="tu" :show-error="false" :show-loading="false" />
                            <div class="mark" v-if="item.images_hide && index == 2">{{'+'+ (item.images.length -3)}}</div>
                        </div>
                    </div>
                </div>
            </div>
		</van-list>
		<van-image-preview v-model="bigTuDingzhiShow" :start-position="bigTuDingzhiIndex" :images="bigTuDingzhiImgArr" @change="bigTuDingzhiChange"></van-image-preview>
	</div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            active: 'a',
            token: null,
            goodsList: [],
            headlineList: [],
            specialList: [],
            loading: false,
            finished: false,
            pages: {
                page: 1,
                size: 10
            },
            loading_toutiao: false,
			finished_toutiao: false,
			bigTuShow: false,
			bigTuIndex: 0,
			bigTuImgArr: null,
			show_more_tu: false, // 加载更多图片，大于3张为真
			have_goods: 1 , // 是否有商品
			loading_dingzhi: true, // 定制单页加载状态
			finished_dingzhi: false, // 定制全部加载状态
			dingzhiList: [], // 定制数据
			bigTuDingzhiShow: false, // 定制大图展示状态
            bigTuDingzhiIndex: 0, // 定制大图展示开始index
            bigTuDingzhiImgArr: null, // 定制大图数组
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我的收藏'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
					this.getGoods()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                responseCallback({})
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
			this.getGoods()
        }

    },
    methods: {
        getGoods() {
            if (this.token == null) {
                return
			}
			this.loading = true
            var params = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
            }
            console.log(params)
            this.$api.my.goodsCollectionList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result
                    console.log(list)
                    // 判断 第一页有没有数据
                    if (this.pages.page == 1 && list.length == 0) {
						// 无数据
						this.have_goods = 0
                        // $(this.$refs.goodsList).css('display', 'none')
						// $(this.$refs.goods).css('display', 'block')
						// this.finished = true
                        return
                    } else {
                        for (var i in list) {
                            this.goodsList.push(list[i])
                        }
                        if (list.length == 0) {
                            this.finished = true
                        }
                    }
                } else {
                    this.$toast(res.message)
                    this.finished = true
                }
                this.pages.page++
				this.loading = false
				// console.log('this.finished',this.finished)
				// console.log('loading',this.loading)
				// console.log('this.pages.page',this.pages.page)
            })
        },
        toGoodsDetail(goods) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?goodsId=" + goods.good_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/shop/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/shop/detail',
                    query: {
                        goodsId: goods.good_id
                    }
                })
            }
        },
        cancelGoodsCollection(goods) {
            var params = {
                token: this.$store.getters.token,
                good_id: goods.good_id,
                type: 1,
            }
            console.log(params)
            this.$api.shop.goodsCollection(params).then(res => {
                if (res.code == 200) {
                    this.$toast('取消收藏成功')
                    this.getGoods()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 无商品时 去首页
        goshop() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                })

            } else {
                this.$router.push({
                    path: '/',
                })
            }
        },
        // 获取头条数据
        getHeadLineList() {
			this.loading_toutiao = true
            var params = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.my.headlineCollectionList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result
                    if (list.length != 0) {
                        for(var i in list){
							// 判断描述是否 多于60个字
							if (list[i].headline_type == 0 && list[i].headline_describe != null && list[i].headline_describe.length > 60) {
								list[i].describe_hide = list[i].headline_describe.slice(0, 60) + '...'
								list[i].desc_hide = 1
							}
							// 多图
							if (list[i].headline_images) {
								list[i].imagesArr = list[i].headline_images.split(',')
							}
							if(list[i].imagesArr && list[i].imagesArr.length > 3){
								var images = list[i].imagesArr
								list[i].images_hide = 1
								list[i].imagesSlice = images.slice(0,3)
							}
							this.headlineList.push(list[i])
						}
                    } else {
                        this.finished_toutiao = true
					}
					// console.log('loading_toutiao',this.loading_toutiao)
                } else {
                    this.finished_toutiao = true
                }
                this.pages.page++
                this.loading_toutiao = false
			})
			console.log('headlineList',this.headlineList)
        },
        // 切换
        changeTab() {			
            this.pages.page = 1
            this.goodsList = []
			this.headlineList = []
			this.dingzhiList = []
			if(this.active == 'a'){
				console.log('this.loading',this.loading)
				this.getGoods()
			}else if(this.active == 'b'){
				console.log('this.loading',this.loading_toutiao)
				this.getHeadLineList()
			}else if(this.active == 'd'){
				this.getDataDingzhi()
			}
		},
		// 去详情
        goDetail: function (item) {
            this.$router.push({
				path: '/toutiao/detail',
				query: {
					headline_id: item.headline_id
				}
            })
		},
		// 查看全部
		lookAllFun(item){
			for(var i in this.headlineList){
				if(this.headlineList[i].headline_id == item.headline_id){
					this.headlineList[i].desc_hide = 0
					return
				}
			}
		},
		// 收起全部
		hideFun(item){
			for(var i in this.headlineList){
				if(this.headlineList[i].headline_id == item.headline_id){
					this.headlineList[i].desc_hide = 1
					return
				}
			}
		},
		// 展开大图   
        zhanshitupian(item, arr, index) {
			for(let i in arr){
				arr[i] = this.imageUrl + arr[i];
			}
			if(index == 2 && item.images_hide){
				for( var i in this.headlineList){
					if(this.headlineList[i].headline_id == item.headline_id){
						this.headlineList[i].images_hide = 0
						return
					}
				}
				return
			}
			this.bigTuImgArr = arr;
			this.bigTuIndex = index;
			this.bigTuShow = true;
        },
		// 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
		},
		// 点击收藏 -- 取消收藏
		clickCollect(item){
			var params = {
				token: this.token,
				headline_id: item.headline_id
			}
			this.$api.toutiao.collect(params).then(res=>{
				if(res.code == 200){
					this.$toast(res.message)
					this.headlineList = []
					this.pages.page = 1
					this.getHeadLineList()
				}
			})
		},
		// 点赞
		clickLike(item){
			var is_like = item.is_like
			var params = {
				token: this.token,
				headline_id: item.headline_id
			}
			this.$api.toutiao.like(params).then(res=>{
				if(res.code == 200){
					for(var i in this.headlineList){
						if(this.headlineList[i].headline_id == item.headline_id){
							if(is_like == 0){
								this.headlineList[i].is_like = 1
								this.headlineList[i].num.like_num = parseInt(this.headlineList[i].num.like_num) + 1
								this.$toast('点赞成功');
							}else if(is_like != 0){
								this.headlineList[i].is_like = 0
								this.headlineList[i].num.like_num = parseInt(this.headlineList[i].num.like_num) - 1
								this.$toast('取消点赞成功');
							}
							return
						}
					}
				}
			})
		},
		// 获取收藏的定制品
		getDataDingzhi(){
			var that = this
			var params = {
				token: that.token,
				page: that.pages.page,
				size: that.pages.size
			}
			that.$api.my.dingzhiCollectionList(params).then(res=>{
				if(res.code == 200){
					var list = []
					list = res.result
					if(list.length != 0){
						for (var i in list) {
							var item = list[i].custommade
							if (item.album != "" && item.album != null) {
								item.images = item.album.split(",");
								if (item.images.length > 3) {
									item.images_hide = 1
									item.imagesSlice = item.images.slice(0, 3)
								}
							}
							that.dingzhiList.push(item)
						}
						that.pages.page++
						that.loading_dingzhi = false
					}else {
						that.finished_dingzhi = true
					}
				}else{
					that.finished_dingzhi = true
				}
			})
		},
		// 匠人店铺中心
        goArtDetail(item) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + item.tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: item.tradesman.id
                    }
                })
            }
		},
		// 去定制详情
        goDingzhiDetail: function (item) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var url = this.$publicData.clientUrl
                if (this.activeType != 1) {
                    url = url + '/dingzhi/detail?id=' + item.id
                } else {
                    url = url + '/dingzhi/detail/user?id=' + item.id
                }
                var params = {
                    'data': {
                        'url': url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: this.activeType == 1 ? '/dingzhi/detail/user' : '/dingzhi/detail',
                    query: {
                        id: item.id
                    }
                })
            }
		},
		// 展开定制大图 
        zhanshiDingzhitupian(item, arr, index, id) {
            if (index == 2 && item.images_hide) {
                for (var i in this.dataList) {
                    if (this.dataList[i].id == item.id) {
                        this.dataList[i].images_hide = 0
                        return
                    }
                }
                return
            }
            this.bigTuDingzhiImgArr = arr;
            this.bigTuDingzhiIndex = index;
            this.bigTuDingzhiShow = true;
		},
		// 切换定制大图
        bigTuDingzhiChange(index) {
            this.bigTuDingzhiIndex = index
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
</style>
